import React from 'react'
import { ButtonGroupProps } from './ButtonGroup.types'
import {
  StyledButtonGroup,
  ActionGroup,
  HeaderActions,
  PropertyActions,
} from './ButtonGroup.styles'

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  variant = 'action',
  children,
  className,
}) => {
  return (
    <StyledButtonGroup $variant={variant} className={className}>
      {children}
    </StyledButtonGroup>
  )
}

// Export pre-configured variants for convenience
export { ActionGroup, HeaderActions, PropertyActions }
